export const sortListings = (listings, sortConfig) => {
    if (!sortConfig.key) return listings;
  
    return [...listings].sort((a, b) => {
      switch (sortConfig.key) {
        case 'upset_value':
          const aValue = a.upset_value_numeric || 0;
          const bValue = b.upset_value_numeric || 0;
          return sortConfig.direction === 'asc' ? aValue - bValue : bValue - aValue;
        
        case 'sale_date':
          const aDate = a.sale_date_raw || 0;
          const bDate = b.sale_date_raw || 0;
          return sortConfig.direction === 'asc' ? aDate - bDate : bDate - aDate;
        
        case 'address':
        case 'city':
        case 'state':
          return sortConfig.direction === 'asc' 
            ? (a[sortConfig.key] || '').localeCompare(b[sortConfig.key] || '')
            : (b[sortConfig.key] || '').localeCompare(a[sortConfig.key] || '');
        
        case 'zillow_estimate':
          const aMarket = a.marketValue || 0;
          const bMarket = b.marketValue || 0;
          return sortConfig.direction === 'asc' ? aMarket - bMarket : bMarket - aMarket;
        
        case 'profit':
        case 'downpayment':
          const aProp = a[sortConfig.key] || 0;
          const bProp = b[sortConfig.key] || 0;
          return sortConfig.direction === 'asc' ? aProp - bProp : bProp - aProp;
        
        default:
          return 0;
      }
    });
  };
  
  export const toggleSortDirection = (currentConfig, newKey) => {
    if (currentConfig.key === newKey) {
      return { 
        ...currentConfig, 
        direction: currentConfig.direction === 'asc' ? 'desc' : 'asc' 
      };
    }
    return { key: newKey, direction: 'asc' };
  };